// extracted by mini-css-extract-plugin
export default {"container":"xZ-z","list":"yZ-z"};